<template>
  <section>
    <div class="card">
      <div class="card-inner">
        <p class="card-title"> Défi(s) envoyé(s) en attente d'acceptation</p>
        <div
          v-if="waiting_challenges.length > 0 && !isAdmin"
          style="text-align: center"
        >
          Vous êtes en attente de l'équipe <strong>{{getWeezyName(waiting_challenges[0].weezy2_id)}}</strong> que vous avez défié !
        </div>
        <div
          v-else-if="waiting_challenges.length > 0 && isAdmin"
          style="text-align: center"
          class="waiting-text"
        >
          <div
            v-for="(chall, index) in waiting_challenges"
            :key="index"
          >
            L'équipe <strong>{{getWeezyName(waiting_challenges[0].weezy1_id)}}</strong> est en attente de l'acceptation de l'équipe <strong>{{getWeezyName(waiting_challenges[0].weezy2_id)}}</strong>
          </div>
        </div>

        <div style="margin-left: 25px; margin-right: 25px; margin-top: 25px; ">
          <b-loading
            :is-full-page="false"
            :active.sync="isLoading"
            :can-cancel="true"
          ></b-loading>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "waitingChallenges",
  props: ["waiting_challenges", "weezys", "isAdmin"],

  data: () => {
    return {
      isEmpty: false,
      isLoading: false
    };
  },
  methods: {
    getWeezyName(fromWeezyId) {
      for (var i = 0; i < this.weezys.length; i++) {
        if (fromWeezyId == this.weezys[i].id) {
          return this.weezys[i].name;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>